/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Products_ProcessingInputs */

const vi_import_products_processing = /** @type {(inputs: Import_Products_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang import sản phẩm, vui lòng chờ...`)
};

/**

* @param {Import_Products_ProcessingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_products_processing = /** @type {((inputs?: Import_Products_ProcessingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Products_ProcessingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_products_processing(inputs)
});